
import { createMuiTheme } from '@material-ui/core/styles';
import { lightTheme, darkTheme } from 'styles/specification';

import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: blue[300],
      main: blue[500],
      dark: blue[700],
    },
    secondary: {
      light: pink[300],
      main: pink[500],
      dark: pink[700],
    },
  },
  typography: {
    useNextVariants: true,
  },
  currentTheme: lightTheme,
  lightTheme,
  darkTheme,
  darkMode: false,
});

export default theme;